<template>
	<div>
		<form class="form-horizontal">
			<ts-loading-banner :loading="loading">
				<div class="row">
					<label class="col-md-5 col-form-label">{{
						$t('paymentTesting.paymentNumber')
					}} :
					</label>
					<div class="col-md-7">
						<input type="text" readonly v-model="resource.payment_number"
							class="form-control-plaintext mb-2" />
					</div>
				</div>
				<div class="row">
					<label class="col-md-5 col-form-label">{{
						$t('paymentTesting.date')
					}} :
					</label>
					<div class="col-md-7">
						<input type="text" readonly v-model="resource.payment_date"
							class="form-control-plaintext mb-2" />
					</div>
				</div>
				<div class="row">
					<label class="col-md-5 col-form-label">{{
						$t('paymentTesting.student')
					}} :
					</label>
					<div class="col-md-7">
						<input type="text" readonly v-model="resource.full_name_en"
							class="form-control-plaintext mb-2" />
					</div>
				</div>
				<div class="row">
					<label class="col-md-5 col-form-label">{{ $t('paymentTesting.subProgram') }} :
					</label>
					<div class="col-md-7">
						<input type="text" readonly v-model="resource.acps_name_foreign"
							class="form-control-plaintext mb-2" />
					</div>
				</div>
				<div class="row">
					<label class="col-md-5 col-form-label">{{ $t('paymentTesting.academicTerm') }} :
					</label>
					<div class="col-md-7">
						<input type="text" readonly v-model="resource.term_name" class="form-control-plaintext mb-2" />
					</div>
				</div>
				<div class="row">
					<label class="col-md-5 col-form-label"> {{ $t('paymentTesting.amount') }} :
					</label>
					<div class="col-md-7">
						<input type="text" readonly v-model="resource.payment_amount"
							class="form-control-plaintext mb-2" />
					</div>
				</div>
				<div class="ts-overflow-auto">
					<table id="table-details" class="ts-mt-6">
						<thead>
							<tr>
								<th class="ts-whitespace-no-wrap" style="width:200px">
									{{ $t('paymentTesting.feeName') }}
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 190px;">
									{{ $t('paymentTesting.description') }}
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 70px;">
									{{ $t('paymentTesting.fee') }}
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 93px;">
									{{ $t('paymentTesting.discountType') }}
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 94px;">
									{{ $t('paymentTesting.discount') }}
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 81px;">
									{{ $t('paymentTesting.vat') }}(%)
								</th>
								<th class="ts-whitespace-no-wrap" style="width: 90px;">
									{{ $t('paymentTesting.amount') }}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(detail, index) in resource.details" :key="index">
								<td valign="top">
									<input type="text" readonly v-model="detail.fee_description"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" readonly v-model="detail.fee_description"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" readonly v-model="detail.fee_amount"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" readonly v-model="detail.discount_type"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" readonly v-model="detail.discount_rate"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" readonly v-model="detail.vat_rate"
										class="form-control-plaintext mb-2" />
								</td>
								<td valign="top">
									<input type="text" readonly v-model="detail.total_amount"
										class="form-control-plaintext mb-2" />
								</td>
							</tr>
						</tbody>
					</table>

				</div>
			</ts-loading-banner>
		</form>
	</div>
</template>
<script>
export default {
	name: 'testingFeeView',
	props: ['resource', 'loading'],
	data() {
		return {
			model: {
				details: []
			}
		}
	}
}
</script>

<style lang="css" scoped>
label {
	font-size: 12px !important;
}

#table-details>thead>tr>th {
	padding: 5px 4px;
	background: #f2f3f4;
}

#table-details>tbody>tr>td {
	padding: 5px 4px;
	border: none !important;
	font-size: 12px !important;
}
</style>

